<script setup>
import { computed, defineProps, toRefs } from 'vue'
import { RouterLink } from "vue-router";
import { parseAndFormatISODateStringToDate } from "../../util/date";
import Card from 'primevue/card'
import Button from 'primevue/button'
import Safe from "../shared/icons/Safe.vue"

const props = defineProps({
  applicationId: {
    type: String,
    required: true,
  },
  formTitle: {
    type: String,
    required: true,
  },
  formLastUpdatedDate: {
    type: String,
    required: false,
  }
});

const emit = defineEmits(['updateForm'])
const { applicationId, formTitle, formLastUpdatedDate } = toRefs(props);

const lastUpdatedString = computed(() => {
  if(formLastUpdatedDate.value) {
    return parseAndFormatISODateStringToDate(formLastUpdatedDate.value, 'LLLL d, y');
  } else {
    return '';
  }
});

const buttonLabel = computed(() => `Update ${formTitle.value}`)
</script>

<template>
  <div class="w-full px-4 pb-4 mx-auto max-w-7xl sm:px-8 sm:pb-8">
    <RouterLink
      :to="{
          name: 'applications/landing',
          params: { applicationId },
        }"
      class="inline-flex items-center text-sm text-gray-700 hover:text-gray-700 mt-4"
    >
      <span class="material-icons-outlined">chevron_left</span>
      <span class="ml-1 font-bold hover:underline">Back</span>
    </RouterLink>
    <Card class="bg-white mt-4">
      <template #header>
        <div class="flex flex-column justify-center pt-10">
          <Safe class="w-40" />
        </div>
      </template>
      <template #title><div class="flex flex-column justify-center">Last Submitted: {{ lastUpdatedString }}</div></template>
      <template #content>
        <div class="flex flex-col justify-center items-center">
          <div>For security reasons, your submitted {{ formTitle }} data is not viewable in the app. You can resubmit at any time if needed.</div>
          <Button class="bg-university-secondary mt-6 w-80" :pt="{ label: 'font-weight-light uppercase' }" :label="buttonLabel" @click="emit('updateForm')"/>
        </div>
      </template>
    </Card>
  </div>
</template>

<style scoped>
</style>
